import React from 'react';
import { MapPin, Clock, Target, TrendingUp, MessageSquare, Calendar, ShieldCheck } from 'lucide-react';
export function ProductSection() {
  const features = [{
    icon: <MapPin className="w-5 h-5 text-gold" data-id="element-221" />,
    title: 'The Exact Loop',
    desc: 'That causes "works alone / fails with her" — explained without jargon'
  }, {
    icon: <Clock className="w-5 h-5 text-gold" data-id="element-222" />,
    title: 'The 90-Second Downshift Sequence',
    desc: 'Discreet, applicable in the moment'
  }, {
    icon: <Target className="w-5 h-5 text-gold" data-id="element-223" />,
    title: '3 Re-Anchor Techniques',
    desc: 'Choose one, install it, use it when the spiral starts'
  }, {
    icon: <TrendingUp className="w-5 h-5 text-gold" data-id="element-224" />,
    title: 'The Fail-Proof Ladder',
    desc: "So you don't panic even when things aren't perfect"
  }, {
    icon: <MessageSquare className="w-5 h-5 text-gold" data-id="element-225" />,
    title: 'Pre-Encounter Script',
    desc: 'How to lower the pressure without making an awkward confession'
  }, {
    icon: <Calendar className="w-5 h-5 text-gold" data-id="element-226" />,
    title: '14-Day Plan',
    desc: 'With a checklist for each night and a tracking system'
  }, {
    icon: <ShieldCheck className="w-5 h-5 text-gold" data-id="element-227" />,
    title: 'Anti-Relapse Protocol',
    desc: "What to do after a bad night so it doesn't become your identity"
  }];
  return <section id="what-you-get" className="py-16 md:py-20 px-4 sm:px-6 bg-dark-card/30 border-t border-dark-border" data-id="element-228">
      <div className="max-w-4xl mx-auto" data-id="element-229">
        <div className="text-center mb-12" data-id="element-230">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold mb-3 text-text-primary" data-id="element-231">
            ERECTILE DIFFUSION GUIDE
          </h2>
          <p className="text-lg md:text-xl text-gold font-medium mb-6" data-id="element-232">
            The Field Manual for Men 50+ Who Want Presence, Not Pills
          </p>
          <p className="text-base text-text-secondary max-w-2xl mx-auto leading-relaxed" data-id="element-233">
            A private 14-day protocol built around a single mechanism:{' '}
            <span className="text-text-primary font-medium" data-id="element-234">
              Stop the spiral before it controls you.
            </span>{' '}
            Not in theory. In real time. Tonight if you want.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-235">
          {features.map((feature, index) => <div key={index} className={index === 6 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''} data-id="element-236">
              <div className="flex items-start gap-3 bg-dark-bg p-5 rounded-xl border border-dark-border hover:border-gold/30 transition-colors h-full" data-id="element-237">
                <div className="mt-0.5 bg-dark-card p-1.5 rounded-lg border border-dark-border" data-id="element-238">
                  {feature.icon}
                </div>
                <div data-id="element-239">
                  <h4 className="text-base font-bold text-text-primary mb-1" data-id="element-240">
                    {feature.title}
                  </h4>
                  <p className="text-text-secondary leading-relaxed" data-id="element-241">
                    {feature.desc}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}